var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8572 1.14286H3.42862L3.42862 2.28571H12.0001C12.9468 2.28571 13.7143 3.05323 13.7143 4V12.5714H14.8572V1.14286ZM3.42862 0C2.79744 0 2.28577 0.511675 2.28577 1.14286V2.28571C2.28577 2.9169 2.79744 3.42857 3.42862 3.42857H12.0001C12.3156 3.42857 12.5715 3.68441 12.5715 4V12.5714C12.5715 13.2026 13.0832 13.7143 13.7143 13.7143H14.8572C15.4884 13.7143 16.0001 13.2026 16.0001 12.5714V1.14286C16.0001 0.511675 15.4884 0 14.8572 0H3.42862Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37143 3.6572V14.6286H12.3429V3.6572H1.37143ZM1.14286 2.28577C0.511675 2.28577 0 2.79744 0 3.42862V14.8572C0 15.4884 0.511674 16.0001 1.14286 16.0001H12.5714C13.2026 16.0001 13.7143 15.4884 13.7143 14.8572V3.42862C13.7143 2.79744 13.2026 2.28577 12.5714 2.28577H1.14286Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.60c46abff40fd67ca6de3485dae92519.svg";
export { ForwardRef as ReactComponent };